import BonusweltSlider from './BonusweltSlider';

export default BonusweltSlider;
